import {Button, Card, Checkbox, Form, Radio, Table, Tag} from "antd";
import React, {useContext, useEffect, useState} from "react";
import Contacte from "../../../model/inscripcions/Contacte";
import {GetAutoritzatsInscripcionsId} from "../../../dao/inscripcions/GetAutoritzatsInscripcionsId";
import {ColumnsType, TableProps} from "antd/es/table";
import InscripcioContacte from "./InscripcioContacte";
import Colors from "../../../styles/Colors";
import {BiArrowBack, BiCheck, BiPencil, BiPlus, BiRefresh, BiTrash, BiX} from "react-icons/bi";
import {BsEye} from "react-icons/bs";
import AutoritzatModal from "./AutoritzatModal";
import {AuthContext} from "../../../config/AuthContext";
import AlumneCasal from "../../../model/inscripcions/AlumneCasal";
import {GetInscripcionsInscripcionsId} from "../../../dao/inscripcions/GetInscripcionsInscripcionsId";
import {PostInscripcionsIdAutoritzacions} from "../../../dao/inscripcions/PostInscripcionsIdAutoritzacions";
import {useParams} from "react-router-dom";
import {GetInscripcionsId} from "../../../dao/inscripcions/GetInscripcionsId";

interface element {
    id_inscripcio: string,
    page: string,
    goBack: () => void,

}

const Autoritzacions = (props: element) => {

    const {id_inscripcio} = useParams();
    const [form] = Form.useForm();
    const [auto, setAuto] = useState<Contacte[]>([]);

    const [isSend, setIsSend] = useState(false);
    const [visible, setVisible] = useState(false);
    const [coleccio, setDades] = useState<Contacte[]>([]);
    const [autoritzats, setAutoritzats] = useState<Contacte[]>([]);
    const [loading, setLoading] = useState(false);

    const [inscripcions, setInscripcions] = useState<AlumneCasal[]>([]);
    const {isLoggedIn, userId, user, page, userDni, userCognom} = useContext(AuthContext);
    const [nouElement, setNouElement] = useState(false);
    const [elementSelected, setElementSelected] = useState<Contacte>(new Contacte());

    useEffect(() => {
        if (userDni !== '' && userCognom !== '') {
            handleLoadingChange(true)
            checkDades();
        }
    }, []);

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetInscripcionsId(props.id_inscripcio + "", props.page);
        const dades2 = await GetInscripcionsInscripcionsId(props.id_inscripcio + "", props.page);
        const dades3 = await GetAutoritzatsInscripcionsId(props.id_inscripcio + "", props.page);
        setAutoritzats(dades);
        setInscripcions(dades2);
        setAuto(dades3);
        await handleLoadingChange(false);
    }


    async function deleteElement(id: number) {
        //await DeleteIngredient(id, page);
        await checkDades();
    }

    function afegirElement(element: Contacte) {
        setNouElement(!nouElement);
        setVisible(true);
        setElementSelected(element);
    }

    function togleNouElement(element: Contacte) {
        setNouElement(!nouElement);
        setVisible(true);
        setElementSelected(element);
    }

    async function handleSubmit() {
        setIsSend(true);
        const formData = form.getFieldsValue();
        //console.log("Form Data:", formData);
        await PostInscripcionsIdAutoritzacions(formData, id_inscripcio+"", page);
        props.goBack();
    }

    function  obtenerFechaActual () {
        const fecha = new Date();
        const fechaFormateada = fecha.toLocaleDateString('ca-ES', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
    })
        return fechaFormateada;
    }

    return (
        <>
            <div className={"actionButtons"}>
                <Button title={"Sortir"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                    props.goBack()}><BiArrowBack/> SORTIR</Button>{" "}
                <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color5}} onClick={() =>
                    checkDades()}><BiRefresh/> REFRESCAR</Button>
            </div>
            <h4 className={"titol"}>{"AUTORITZACIONS"}</h4>

            <Form form={form} onFinish={handleSubmit}>
                <Card bordered={true} className={"elemento"}>

                    <p>
                        <p>Badalona, {obtenerFechaActual()}.</p>
                        <br/>
                        <p>En/na:</p>
                        {autoritzats.map(contacte =>
                            (<p><b>{contacte.nom}{" "}{contacte.cognoms}</b>{" amb DNI: "}{contacte.dni}</p>)
                        )}<br/><br/>
                        <Form.Item name="imatge"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Radio.Group>
                                <Radio value={"1"} checked={true} > <Tag color={"success"}>Autoritzo</Tag> </Radio>
                                <Radio value={"0"}> <Tag color={"red"}> No Autoritzo </Tag> </Radio>
                            </Radio.Group>
                        </Form.Item>
                        <br/><br/>
                        <p>a que atenguin els rebuts presentats per l'empresa ART I ESPORT Badalona corresponents als
                            infants:</p><br/>

                        {inscripcions.map(alumne =>
                            (<><b>{alumne.nom}{" "}{alumne.cognoms}</b>{" - "}{alumne.activitat}<br/></>)
                        )}
                        <br/>
                        <br/>
                        <p>Les dades personals recollides seran incorporades i tractades en el fitxer de l'empresa ART I
                            ESPORT Badalona, la finalitat del qual és la de gestionar les comunicacions entre l'empresa ART
                            I ESPORT Badalona.
                            i els pares i mares dels alumnes, la gestió i cobrament de les activitats organitzades per ART I
                            ESPORT Badalona. El fitxer es troba inscrit en el Registre de Fitxers de Dades Personals de
                            l'Agència
                            Espanyola de Protecció de Dades i podrà ser cedit segons preveu la Llei. L'òrgan responsable del
                            fitxer és l'empresa ART I ESPORT Badalona i l'adreça on l'interessat podrà exercir els seus
                            drets
                            d'accés, rectificació, cancel·lació i oposició davant l'empresa ART I ESPORT Badalona es de Via
                            augusta 43 08912 Badalona (Barcelona), tot el qual s'informa En compliment del Reglament General
                            de
                            Protecció de Dades, UE-2016/679, i segons els articles, 5,6 i 7de la Llei Orgànica 15/1999 de 13
                            de desembre.</p>
                    </p>
                </Card>
                {auto.length > 0 && (
                    <>
                    <hr />
                    <Card bordered={true} className={"elemento"}>

                        <p>
                            <p>Badalona, 26 de April del 2024.</p>
                            <br/>
                            <p>En/na:</p>
                            {autoritzats.map(contacte =>
                                (<p><b>{contacte.nom}{" "}{contacte.cognoms}</b>{" amb DNI: "}{contacte.dni}</p>)
                            )}<br/><br/>
                            <Form.Item name="recollir"
                                       rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <Radio.Group>
                                    <Radio value={"1"} checked={true} > <Tag color={"success"}>Autoritzo</Tag> </Radio>
                                    <Radio value={"0"}> <Tag color={"red"}> No Autoritzo </Tag> </Radio>
                                </Radio.Group>
                            </Form.Item>
                            <br/><br/>
                            <p>a que els menors:</p><br/>

                            {inscripcions.map(alumne =>
                                (<><b>{alumne.nom}{" "}{alumne.cognoms}</b><br/></>)
                            )}
                            <br/>
                            <br/>
                            <p>Puguin ser recollits per els autoritzats:</p>
                            <br/>
                            {auto.map(contacte =>
                                (<p><b>{contacte.nom}{" "}{contacte.cognoms}{" ("}{contacte.parentesc}{")"}</b></p>)
                            )}<br/><br/>
                        </p>
                    </Card>
                    </>
                )}
                <hr />
                <Card bordered={true} className={"elemento"}>
                    <p>
                        <p>Badalona, 26 de April del 2024.</p>
                        <br/>
                        <p>En/na:</p>
                        {autoritzats.map(contacte =>
                            (<b>{contacte.nom}{" "}{contacte.cognoms}</b>)
                        )}<br/>
                        <br/><br/>
                        <Form.Item name="notificacions"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Radio.Group>
                                <Radio value={"1"} checked={true}> <Tag color={"success"}>Autoritzo</Tag> </Radio>
                                <Radio value={"0"}> <Tag color={"red"}> No Autoritzo </Tag> </Radio>
                            </Radio.Group>
                        </Form.Item>
                        <br/><br/>
                        <p>a ser contactats per ART I ESPORT Badalona amb la finalitat de notificar els documents necesaris
                            per la formalització de la matricula dels infants inscrits.</p>
                    </p>
                </Card>
                <hr />
                <Form.Item wrapperCol={{offset: 0, span: 16}}> {" "}
                        <Button htmlType={"submit"}  title={"Finalitzar"} disabled={isSend}
                                style={{backgroundColor: Colors.colors.color6}}>FINALITZAR <BiCheck/> </Button>
                </Form.Item>
            </Form>
        </>
    );

};

export default Autoritzacions;